import React, { useRef, useEffect } from "react";
import { Space, Box, Group } from "@mantine/core";
import { TransactionProfitDistributionDoc } from "../api/type";
import { useGlobalStatusContext } from "../GlobalStore";
import { EpAlert } from "../Components/EpMessage";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { FromNow } from "../Components/FromNow";
import { chartColors } from "../Components/Highcharts";
import { useFireStoreQuery } from "../Components/useFireStoreQuery";
import { amountPlus, nFormatter } from "../Components/Utils";
import { TdText } from "../Components/EpTable";

export const TranscationProfitDistribution = React.memo(function ({
  chain,
  address,
}: {
  chain?: string;
  address?: string;
}) {
  const { period, navExpand } = useGlobalStatusContext();
  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

  let dbPath = `/${chain}/${period}d/tx_profit_distribution`;
  if (address) {
    dbPath = `/${chain}/${period}d/contract_tx_profit_distribution/default/${address}`;
  }

  const { data, isLoading } =
    useFireStoreQuery<TransactionProfitDistributionDoc>({
      path: dbPath,
    });
  /*
  const { data, isLoading } = useQuery<
    {
      rows: Array<TransactionProfitDistributionItem>;
      updateTimestamp: number;
      updateBlockNumber: number;
    },
    TransactionProfitDistributionParams
  >([
    "fetchTransactionProfitDistribution",
    {
      period,
      chain,
      toAddress: address,
    },
  ]);
  */
  //  console.log('data', data)
  useEffect(() => {
    if (isLoading) {
      chartComponentRef.current?.chart.showLoading();
    } else {
      chartComponentRef.current?.chart.hideLoading();
    }
  }, [isLoading]);

  useEffect(() => {
    chartComponentRef.current?.chart.reflow();
  }, [navExpand]);

  if (!isLoading && !data?.data?.length) {
    return <EpAlert>Data Not Found!</EpAlert>;
  }

  const totalCount = data?.data?.reduce(
    (total, item) => (total += item.count),
    0
  );
  const probabilities = data?.data?.map(
    (item) => item.count / (totalCount || 0)
  );

  const options: Highcharts.Options = {
    chart: {
      type: "column",
      height: 413,
    },
    title: {
      text: "",
    },
    subtitle: {
      text: "",
    },
    xAxis: {
      min: -1, // 设置 x 轴的最小值
      categories: data?.data?.map((item) => item.range),
      crosshair: true,
      labels: {
        formatter: function () {
          if ((this as any).value === -1) {
            const endProfit = Number(data?.data[0].range);
            let startProfit = 0;
            if (endProfit === 0 || endProfit === 10) {
              startProfit = endProfit - 10;
            } else if (endProfit > 10) {
              startProfit = endProfit / 10;
            } else {
              startProfit = endProfit * 10;
            }
            return `$${nFormatter(startProfit)}`;
          }

          return `$${nFormatter((this as any).value)}`;
        },
      },
    },
    yAxis: {
      min: 0,
      max: 1,
      title: {
        text: "PDF of Transactions' Profit",
      },
    },
    tooltip: {
      formatter: function () {
        const endProfit = Number((this as any).x);
        let startProfit = 0;
        if (endProfit === 0 || endProfit === 10) {
          startProfit = endProfit - 10;
        } else if (endProfit > 10) {
          startProfit = endProfit / 10;
        } else {
          startProfit = endProfit * 10;
        }
        let tableHtml = `<table><tr><th colspan="2">$${nFormatter(
          startProfit
        )}~$${nFormatter(endProfit)}</th></tr>`;

        (
          (this as any)
            ?.points as Array<Highcharts.TooltipFormatterContextObject>
        ).forEach(function (point) {
          tableHtml += `<tr><td><span style='color: ${
            point.color
          };font-size: 14px'>●</span> PDF of Transactions' Profit:</td><td style="text-align: right"><b>${
            point.y === 0 ? 0 : amountPlus(point.y || 0, 4)
          }</b></td></tr>`;
        });

        tableHtml += "</table>";

        return tableHtml;
      },
      shared: true,
      useHTML: true,
    },
    plotOptions: {
      column: {
        pointPadding: 0,
        borderWidth: 0,
        groupPadding: 0,
        shadow: false,
      },
    },
    series: [
      {
        name: "Transaction Profit($)",
        data: probabilities || [],
        color: chartColors.blue,
        pointPlacement: -0.5, // 左移半格
      },
    ],
  } as any;

  // const options = {
  //   title: {
  //     text: "Highcharts Histogram",
  //   },

  //   xAxis: {
  //     title: { text: "Range" },
  //     type: "category",
  //     // labels: {
  //     //   formatter: function () {
  //     //     return processedData[this.value]?.name || "";
  //     //   },
  //     // },
  //   },

  //   yAxis: {
  //     title: { text: "Count" },
  //   },

  //   plotOptions: {
  //     column: {
  //       borderWidth: 0,
  //     },
  //   },

  //   series: [
  //     {
  //       name: "Histogram",
  //       type: "column",
  //       data: processedData,
  //     },
  //   ],
  // };

  // const options: Highcharts.Options = {
  //   chart: {
  //     height: 413,
  //   },
  //   title: {
  //     style: {
  //       display: "none",
  //     },
  //   },
  //   plotOptions: {
  //     line: {},
  //     areaspline: {
  //       tooltip: {
  //         valueDecimals: 2,
  //         valuePrefix: "$",
  //       },
  //       dataLabels: {
  //         enabled: true,
  //       },
  //     },
  //   },
  //   tooltip: {
  //     shared: true,
  //   },
  //   xAxis: [
  //     {
  //       categories: data?.data?.map((item) => item.range),
  //     },
  //   ],
  //   yAxis: [
  //     {
  //       title: {
  //         text: "PDF of Transactions' Profit",
  //         style: {
  //           color: leftYAxisColor,
  //         },
  //       },
  //       labels: {
  //         style: {
  //           color: leftYAxisColor,
  //         },
  //       },
  //     },
  //   ],
  //   series: [
  //     {
  //       name: "PDF of Transactions' Profit",
  //       type: "spline",
  //       data: probabilities?.map((item) => parseFloat(item.toFixed(2))) ?? [],
  //       // data: data?.data?.map((item) => parseInt(item.count + "")) ?? [],
  //       // yAxis: 1,
  //       color: chartColors.blue,
  //     },
  //   ],
  // };

  return (
    <>
      <Space h={20} />
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        ref={chartComponentRef}
      />
      <Box
        sx={(theme) => ({
          padding: "9px 20px",
          borderTop:
            theme.colorScheme === "dark"
              ? `1px solid ${theme.colors.dark[6]}`
              : `1px solid ${theme.colors.gray[2]}`,
        })}
      >
        <Group w="100%" position="apart" noWrap>
          <FromNow
            isLoading={isLoading}
            updateTimestamp={data?.updateTimestamp!}
            updateBlockNumber={data?.updateBlockNumber!}
          />
          <TdText size="xs">*PDF: Probability Density Function</TdText>
        </Group>
      </Box>
    </>
  );
});
export default TranscationProfitDistribution;
